import { supabase } from './supabase';

// Columns staff may read directly. Medical and special-needs answers are not among them: the database refuses them
// (and `select *`) for every staff role; admins get them through `fetchSensitive`. Keep in step with the column
// grant in supabase/migrations/20261005000008_application_admin.sql.
export const APPLICATION_COLUMNS = [
  'id', 'reference_number', 'academic_year', 'consent_at', 'consent_policy_version',
  'utm_source', 'utm_medium', 'utm_campaign', 'referrer',
  'student_first_name', 'student_last_name', 'date_of_birth', 'gender', 'grade',
  'parent_first_name', 'parent_last_name', 'email', 'phone', 'address', 'city', 'state', 'zip_code',
  'emergency_contact_name', 'emergency_contact_phone', 'emergency_contact_relation',
  'previous_school', 'how_did_you_hear', 'comments',
  'status', 'viewed_at', 'viewed_by', 'processed_by', 'interview_at', 'duplicate_of', 'created_at', 'updated_at'
].join(', ');

export const STATUSES = [
  { value: 'pending', label: 'Pending', color: '#9a5b00' },
  { value: 'viewed', label: 'Viewed', color: '#1f618d' },
  { value: 'reviewing', label: 'Reviewing', color: '#6c3483' },
  { value: 'document-pending', label: 'Document Pending', color: '#a04000' },
  { value: 'interview-scheduled', label: 'Interview Scheduled', color: '#0e6655' },
  { value: 'processing', label: 'Processing', color: '#34495e' },
  { value: 'approved', label: 'Approved', color: '#1e8449' },
  { value: 'rejected', label: 'Rejected', color: '#b03a2e' },
  { value: 'waitlist', label: 'Waitlist', color: '#5f6a6a' },
  { value: 'withdrawn', label: 'Withdrawn', color: '#566573' }
];

// All colours carry white text (status badges): each is dark enough for WCAG AA contrast (see accessibility.test.js).
export const statusColor = (status) => STATUSES.find((s) => s.value === status)?.color ?? '#566573';
export const statusLabel = (status) => STATUSES.find((s) => s.value === status)?.label ?? status;

const SENSITIVE_CHUNK = 5000;

// Medical and special-needs answers by application id ({ [id]: { medical_conditions, special_needs } }).
// Admins and super-admins only. `purpose` is 'view', 'print' or 'export'; prints and exports are audit-logged.
export async function fetchSensitive(ids, purpose = 'view') {
  const out = {};
  for (let i = 0; i < ids.length; i += SENSITIVE_CHUNK) {
    const { data, error } = await supabase.rpc('get_application_sensitive', {
      p_ids: ids.slice(i, i + SENSITIVE_CHUNK),
      p_purpose: purpose
    });
    if (error) throw error;
    for (const row of data ?? []) out[row.id] = row;
  }
  return out;
}

// For <input type="datetime-local">: an ISO timestamp as local "YYYY-MM-DDTHH:MM", and back.
export const toLocalInput = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
export const fromLocalInput = (value) => (value ? new Date(value).toISOString() : null);
